
import React from 'react'
import { IProject } from './core/_models'
import { ProjectCard } from '../../modules/project/components/ProjectCard'

type Props = {
  projects:IProject[]
}

const ProjectGrid: React.FC<Props> = ({projects}) => {
  return (
    <div className='row g-6 g-xl-9 mb-8'>
        {
            projects.map((project:IProject) => {
                return <div className='col-md-6 col-xl-3'><ProjectCard 
                    project={project}
                /></div>
            })
        }
    </div>     
  )
}

export {ProjectGrid}
